<template>
  <div id="app">
    <MainHeader />
    <router-view />
  </div>
</template>

<script>
import MainHeader from "@/components/header/MainHeader.vue";

export default {
  name: "MainApp",
  components: {
    MainHeader,
  },
  methods: {
    onResize() {
      this.$store.commit("updateWindow", window.innerWidth);
    },
    setBrowserClasses() {
      const ua = navigator.userAgent || "";
      const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
      const isChromeMobile = isMobile && /Chrome|CriOS/i.test(ua);
      document.documentElement.classList.toggle(
        "is-chrome-mobile",
        isChromeMobile
      );
    },
    updateBrowserUiOffset() {
      const viewport = window.visualViewport;
      if (!viewport) {
        document.documentElement.style.setProperty(
          "--browser-ui-offset",
          "0px"
        );
        return;
      }

      // Reserve space for browser UI (e.g. Chrome mobile bottom bar).
      const uiOffset = Math.max(
        0,
        window.innerHeight - (viewport.height + viewport.offsetTop)
      );
      document.documentElement.style.setProperty(
        "--browser-ui-offset",
        `${Math.round(uiOffset)}px`
      );
    },
  },
  mounted() {
    this.onResize();
    this.setBrowserClasses();
    this.updateBrowserUiOffset();
    window.addEventListener("resize", this.onResize);
    window.addEventListener("resize", this.updateBrowserUiOffset);
    if (window.visualViewport) {
      window.visualViewport.addEventListener(
        "resize",
        this.updateBrowserUiOffset
      );
      window.visualViewport.addEventListener(
        "scroll",
        this.updateBrowserUiOffset
      );
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("resize", this.updateBrowserUiOffset);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener(
        "resize",
        this.updateBrowserUiOffset
      );
      window.visualViewport.removeEventListener(
        "scroll",
        this.updateBrowserUiOffset
      );
    }
  },
};
</script>

<style>
@import "./assets/styles/general.css";
</style>
